module.exports = __webpack_public_path__ + "static/media/place-artifact.11a893bc.gif";